import useNews from "hooks/useNews";
import AddNewsModal from "./AddNewsModal";
import { FirebaseError } from "firebase/app";
import News from "./News";
import DefaultTemplate from "components/templates/DefaultTemplate";
import BackButton from "components/molecules/BackButton";

const HomeEdit = () => {
    const { news, getNews, isLoading } = useNews();
    if (isLoading) getNews();

    return (
        <DefaultTemplate isAdmin={true} style={{ textAlign: "center" }}>
            <BackButton />
            {isLoading ? (
                <h2>Now Loading...</h2>
            ) : (
                <>
                    {news.map((val) => (
                        <News
                            key={val.id}
                            title={val.title}
                            text={val.text}
                            image={val.image}
                            date={val.date}
                            id={val.id}
                            afterNewsDelete={getNews}
                            afterNewsUpdate={getNews}
                        />
                    ))}
                    <AddNewsModal
                        buttonValue="追加"
                        successFunc={() => getNews()}
                        failFunc={(e) => {
                            if (e instanceof FirebaseError) {
                                alert(
                                    `エラー\n下記の内容と共に問い合わせをお願い致します\n${e.code}`
                                );
                            } else if (e instanceof Error) {
                                alert(
                                    `エラー\n下記の内容と共に問い合わせをお願い致します\n${e.message}`
                                );
                            } else {
                                alert(
                                    "不明なエラー\n問い合わせをお願い致します"
                                );
                            }
                        }}
                    ></AddNewsModal>
                </>
            )}
        </DefaultTemplate>
    );
};

export default HomeEdit;
